import { useState } from "react";
import { ChatMessage, ChatConfig, ChatState } from "@/components/landing2/chat/types";
import { trackEvent } from "@/lib/plausible";

export const isGitHubMessage = (text: string) =>
  /github|git\.com|connect\s*git|i'?ll\s*connect/i.test(text);

export const useChatFlow = (config: ChatConfig): ChatState => {
  const [step, setStep] = useState(0);
  const [messages, setMessages] = useState<ChatMessage[]>([]);
  const [input, setInput] = useState("");
  const [typing, setTyping] = useState(false);

  const send = (text: string) => {
    if (!text.trim()) {
      return;
    }
    setMessages(m => [...m, { role: "user", text }]);
    setInput("");
    setTyping(true);

    if (messages.length === 0) {
      trackEvent(`${config.trackPrefix}_ChatStarted`);
    }

    if (isGitHubMessage(text)) {
      trackEvent(`${config.trackPrefix}_GitHubSelected`);
      setTimeout(() => {
        setMessages(m => [...m, config.githubReply]);
        setTyping(false);
        setStep(99);
      }, 950);
      return;
    }

    const reply = config.replies[step];
    if (!reply) {
      setTyping(false);
      return;
    }
    setTimeout(() => {
      setMessages(m => [
        ...m,
        {
          role: "ai" as const,
          text: reply.text,
          chips: reply.chips ? [...reply.chips] : undefined,
          cta: reply.cta
        }
      ]);
      setTyping(false);
      setStep(s => s + 1);
    }, 950);
  };

  const reset = () => {
    setStep(0);
    setMessages([]);
    setInput("");
    setTyping(false);
  };

  return { step, messages, input, setInput, typing, send, reset };
};
